import Vue from 'vue'
import Router from 'vue-router'
import store from './../vuex/store'
import config from '@/common/config'
Vue.use(Router)

const error = r => require.ensure([], () => r(require('@/components/error/404')), 'error')
const home = r => require.ensure([], () => r(require('@/page/home/home')), 'home')
/* 首页 */
const dataIndex = r => require.ensure([], () => r(require('@/page/index/index')), 'dataIndex')

/* 用户中心 */
const personal = r => require.ensure([], () => r(require('@/page/user/personal')), 'personal')
const editmobile = r => require.ensure([], () => r(require('@/page/user/editmobile')), 'editmobile')
const editemail = r => require.ensure([], () => r(require('@/page/user/editemail')), 'editemail')
const addemail = r => require.ensure([], () => r(require('@/page/user/addemail')), 'addemail')
// 产品
const hulk = r => require.ensure([], () => r(require('@/page/product/haoke')), 'hulk')
const banner = r => require.ensure([], () => r(require('@/page/product/banner')), 'banner')
const flow = r => require.ensure([], () => r(require('@/page/product/flow')), 'flow')
const jiance = r => require.ensure([], () => r(require('@/page/product/jiance')), 'jiance')
const scan = r => require.ensure([], () => r(require('@/page/product/scan')), 'scan')
const honeynet = r => require.ensure([], () => r(require('@/page/product/honeynet')), 'honeynet')

// 服务
const apply = r => require.ensure([], () => r(require('@/page/service/apply')), 'apply')
const trends = r => require.ensure([], () => r(require('@/page/service/trends')), 'trends')
const monitor = r => require.ensure([], () => r(require('@/page/service/monitor')), 'monitor')
const fragility = r => require.ensure([], () => r(require('@/page/service/fragility')), 'fragility')
// 服务其他
const permeate = r => require.ensure([], () => r(require('@/page/service/other/permeate')), 'permeate')
const response = r => require.ensure([], () => r(require('@/page/service/other/response')), 'response')
const security = r => require.ensure([], () => r(require('@/page/service/other/security')), 'security')
const protect = r => require.ensure([], () => r(require('@/page/service/other/protect')), 'protect')
const match = r => require.ensure([], () => r(require('@/page/service/other/match')), 'match')
const insure = r => require.ensure([], () => r(require('@/page/service/other/insure')), 'insure')

// 客户案例
const custom = r => require.ensure([], () => r(require('@/page/custom/custom')), 'custom')
const customdetail = r => require.ensure([], () => r(require('@/page/custom/customdetail')), 'customdetail')

//合作计划
const cooperate = r => require.ensure([], () => r(require('@/page/custom/cooperate')), 'cooperate')

//行业动态
const industry = r => require.ensure([], () => r(require('@/page/custom/industry')), 'industry')
const industrydetail = r => require.ensure([], () => r(require('@/page/custom/industrydetail')), 'industrydetail')

//关于我们
const aboutus = r => require.ensure([], () => r(require('@/page/aboutus/index')), 'aboutus')

//隐私政策
const policy = r => require.ensure([], () => r(require('@/page/policy/index')), 'policy')


const emptyVue = r => require.ensure([], () => r(require('@/page/empty')), 'empty')
/* meta: menu: 模块名称(一级菜单) navLevel:二级菜单 active */
let routes = [
    {
        path: '/',
        name: 'home',
        component: home,
        redirect: { name: 'dataIndex' },
        children: [
            {  // 首页
                path: 'index',
                name: 'dataIndex',
                component: dataIndex,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            //用户中心
            {
                path: 'personal',
                name: 'personal',
                component: personal,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'editmobile',
                name: 'editmobile',
                component: editmobile,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'editemail',
                name: 'editemail',
                component: editemail,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'addemail',
                name: 'addemail',
                component: addemail,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            // 产品页
            {
                path: 'hulk',
                name: 'hulk',
                component: hulk,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'banner',
                name: 'banner',
                component: banner,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'flow',
                name: 'flow',
                component: flow,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'jiance',
                name: 'jiance',
                component: jiance,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'scan',
                name: 'scan',
                component: scan,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'honeynet',
                name: 'honeynet',
                component: honeynet,
                meta: { menu: 'index', navLevel: 'indexManage' },
            },
            {
                path: 'data',
                name: 'dataPerception',
                component: emptyVue,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            // 服务页
            {
                path: 'apply',
                name: 'apply',
                component: apply,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'trends',
                name: 'trends',
                component: trends,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'monitor',
                name: 'monitor',
                component: monitor,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'fragility',
                name: 'fragility',
                component: fragility,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            { // 其他服务
                path: 'permeate',
                name: 'permeate',
                component: permeate,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'response',
                name: 'response',
                component: response,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'security',
                name: 'security',
                component: security,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'protect',
                name: 'protect',
                component: protect,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'match',
                name: 'match',
                component: match,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'insure',
                name: 'insure',
                component: insure,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            // 客户案例
            {
                path: 'custom',
                name: 'custom',
                component: custom,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'detail',
                name: 'customdetail',
                component: customdetail,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            //合作计划
            {
                path: 'cooperate',
                name: 'cooperate',
                component: cooperate,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            //行业动态
            {
                path: 'industry',
                name: 'industry',
                component: industry,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            {
                path: 'industrydetail',
                name: 'industrydetail',
                component: industrydetail,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },

            //关于我们
            {
                path: 'aboutus',
                name: 'aboutus',
                component: aboutus,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
            //隐私政策
            {
                path: 'privacy',
                name: 'policy',
                component: policy,
                meta: { menu: 'data', navLevel: 'dataManage' },
            },
        ]
    },
    {
        path: '*',
        component: error
    }
]
let router = new Router({
    'linkActiveClass': 'active',
    routes: routes,
    base: '/',
    mode: 'history',
    fallback: false
})
// 导航守卫
var box = new Vue
router.beforeEach((to, from, next) => {
    // 第一步 先去vuex拉取用户信息
    let info = store.state.userInfo
    let infoLength = Object.keys(info).length === 0
    // infoLength为true 说明是第一次访问系统或者刷新页面,在这里判断路由'/login'，防止进入死循环。未登录，status为1，跳到登录页面，已登录，status为0，继续访问页面
    if (infoLength) {
        store.dispatch('getUserInfo').then((response) => {
            if (response.status === '0') {
                store.dispatch('userLogin', response.data) // 将用户基本信息存入vuex
            }
            // if (response.status === '0') {
            //     store.dispatch('userLogin', response.data) // 将用户基本信息存入vuex
            //     if(response.data.password_expired ==1){
            //         box.messageBox('您的密码已超过有效期，请重新修改密码','error')
            //         next({name: "modifyPassword"})
            //         return true
            //     }
            //     next()
            // } else if (response.status === '1') {
            //     window.open(`${config.loginUrl}login?redirect=${window.location.href}`, '_self')
            // } else if (response.status === '2') { // 刷新时登录失效
            //     window.open(`${config.loginUrl}login?redirect=${window.location.href}`, '_self')
            // }
            next()
        })
    } else { // infoLength为false 说明是静态点击，不需要任何操作
        // if(info.password_expired==1&&to.name!='modifyPassword') {
        //     box.messageBox('您的密码已超过有效期，请重新修改密码','error')
        //     next({name: "modifyPassword"})
        //     return true
        // }
        next()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/jvsit/router/index.js